import EditChannel from './EditChannel';

export default EditChannel;
export { EditChannel };
